{
  "2019": {
      "Jan": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "analytics": {
          "Bill": 1998.63,
          "Grocery": 2300.7999999999993,
          "Leisure": 3369.1899999999996,
          "Restuarant": 250,
          "Shopping": 1590.9299999999996,
          "Travel": 50,
          "Shopping ": 210.06
      },
      "Feb": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Mar": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Apr": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "May": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Jun": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Jul": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Aug": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Sep": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Oct": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Nov": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Dec": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      }
  },
  "2020": {
      "Jan": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "analytics": {
          "Bill": 1896.3,
          "Grocery": 2313.7299999999996,
          "Leisure": 3082.650000000001,
          "Restuarant": 1088.2,
          "Shopping": 250,
          "Travel": 2359.0000000000005,
          "Shopping ": 4140.04
      },
      "Feb": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Mar": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Apr": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "May": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Jun": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Jul": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Aug": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Sep": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Oct": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Nov": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Dec": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      }
  },
  "2021": {
      "Dec": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "analytics": {
          "Bill": 27891.79999999999,
          "Grocery": 3578.290000000001,
          "Leisure": 4176.130000000001,
          "Restuarant": 1926.8400000000006,
          "Shopping": 3243.2300000000014,
          "Travel": 2538.959999999999,
          "Shopping ": 280.08,
          "Travel    ": 83.96
      },
      "Nov": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Oct": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Sep": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "Travel ": [{
              "Expense Description": "Uber",
              "Expenditure": "4.47",
              "Category": "Travel ",
              "Mode of Payment": "Discover"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38,
              "Travel ": 4.47
          }
      },
      "Aug": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Jul": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Jun": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "Travel ": [{
              "Expense Description": "Uber",
              "Expenditure": "4.47",
              "Category": "Travel ",
              "Mode of Payment": "Discover"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38,
              "Travel ": 4.47
          }
      },
      "May": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Apr": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Mar": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "Travel ": [{
              "Expense Description": "Uber",
              "Expenditure": "4.47",
              "Category": "Travel ",
              "Mode of Payment": "Discover"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38,
              "Travel ": 4.47
          }
      },
      "Feb": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Jan": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }, {
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 19465.919999999995,
              "Grocery": 1549.1799999999994,
              "Leisure": 1563.87,
              "Restuarant": 886.8100000000003,
              "Shopping": 1607.0100000000002,
              "Shopping ": 140.04,
              "Travel": 745.9400000000003,
              "Travel    ": 83.96
          },
          "Travel    ": [{
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel    ",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel    ",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel    ",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel    ",
              "Mode of Payment": "Capital One - QS"
          }]
      }
  },
  "2022": {
      "Jan": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "analytics": {
          "Bill": 20958.87,
          "Grocery": 2362.7999999999997,
          "Leisure": 200,
          "Restuarant": 1054.4600000000003,
          "Shopping": 2800,
          "Travel": 2477.32,
          "Shopping ": 140.04
      },
      "Feb": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Mar": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Apr": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "May": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Jun": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Jul": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      },
      "Aug": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "72.23",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "59.73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }],
          "Grocery": [{
              "Expense Description": "Amazon - Dove Bodywash",
              "Expenditure": "10.59",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Laces",
              "Expenditure": "7.01",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "71.29",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.98",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.35",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Foodland (Fields Corner)",
              "Expenditure": "31.59",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "3.62",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Shipt - Target",
              "Expenditure": "36.19",
              "Category": "Grocery",
              "Mode of Payment": "WF Credit"
          }],
          "Leisure": [{
              "Expense Description": "Qawwali - Ali Sethi Concert",
              "Expenditure": "24",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Wachusset Mountain (ZipCar + Biryani)",
              "Expenditure": "120",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Book - Ghazi and the Gulistan",
              "Expenditure": "37.07",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "McGolf",
              "Expenditure": "20",
              "Category": "Leisure",
              "Mode of Payment": "Amex Gold"
          }],
          "Restuarant": [{
              "Expense Description": "McDonalds",
              "Expenditure": "1.07",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preffered"
          }, {
              "Expense Description": "Uber Eats - Burger King",
              "Expenditure": "13.66",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Bab Al Yemen",
              "Expenditure": "57.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "McDonalds",
              "Expenditure": "4.47",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Preferred"
          }, {
              "Expense Description": "Uber Eats - Shah Halal Food",
              "Expenditure": "19.71",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }],
          "Shopping": [{
              "Expense Description": "Amazon - Luggage",
              "Expenditure": "26.62",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "16.33",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "SF Magnet",
              "Expenditure": "6.69",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "15.01",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "H&M",
              "Expenditure": "50.03",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "CVS Lipstick",
              "Expenditure": "12.21",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Nike - Socks",
              "Expenditure": "18",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Adidas (Gift Card = 35 + 15)",
              "Expenditure": "35",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uniqlo",
              "Expenditure": "39.9",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "10.97",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.34",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "19.7",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber ",
              "Expenditure": "11.65",
              "Category": "Travel",
              "Mode of Payment": ""
          }, {
              "Expense Description": "Uber",
              "Expenditure": "7.94",
              "Category": "Travel",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "14.79",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Lyft (Saturday)",
              "Expenditure": "20.99",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2136.83,
              "Grocery": 211.62000000000003,
              "Leisure": 201.07,
              "Restuarant": 96.16999999999999,
              "Shopping": 219.79000000000002,
              "Travel": 97.38
          }
      },
      "Sep": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "74.12",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "6.49",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "3.78",
              "Category": "Grocery",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "2.38",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market",
              "Expenditure": "5.5",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Amazon - Electirc Shaver Charger",
              "Expenditure": "7.43",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Amazon - Sewing Needles",
              "Expenditure": "5.3",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Shipt - Shaw's Market",
              "Expenditure": "23.16",
              "Category": "Grocery",
              "Mode of Payment": "Wells Fargo Credit"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb",
              "Expenditure": "30.9",
              "Category": "Leisure",
              "Mode of Payment": "Amex Everyday"
          }, {
              "Expense Description": "New England Zoo",
              "Expenditure": "50.9",
              "Category": "Leisure",
              "Mode of Payment": "Chase"
          }],
          "Restuarant": [{
              "Expense Description": "The Helmand",
              "Expenditure": "60",
              "Category": "Restuarant",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Starbucks",
              "Expenditure": "5.3",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Caffe Nero",
              "Expenditure": "14.5",
              "Category": "Restuarant",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber Eats - Sufra Medditerrenean ",
              "Expenditure": "15.44",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }],
          "Shopping": [{
              "Expense Description": "IndoChino",
              "Expenditure": "30",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Primark",
              "Expenditure": "41",
              "Category": "Shopping",
              "Mode of Payment": "Amex Gold"
          }],
          "Shopping ": [{
              "Expense Description": "Uniqlo",
              "Expenditure": "70.02",
              "Category": "Shopping ",
              "Mode of Payment": "WF Credit"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "6.93",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.51",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "3.7",
              "Category": "Travel",
              "Mode of Payment": "Amex Gold"
          }, {
              "Expense Description": "Uber (Hamza's Ride)",
              "Expenditure": "73.24",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }],
          "analytics": {
              "Bill": 2213.2099999999996,
              "Grocery": 54.04,
              "Leisure": 81.8,
              "Restuarant": 95.24,
              "Shopping": 71,
              "Shopping ": 70.02,
              "Travel": 99.38
          }
      },
      "Oct": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "133.05",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "86.07",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Tax Payment to MA",
              "Expenditure": "73",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Audible",
              "Expenditure": "14.95",
              "Category": "Bill",
              "Mode of Payment": "Discover"
          }],
          "Grocery": [{
              "Expense Description": "K&Ns",
              "Expenditure": "137.88",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "21.72",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Vicks",
              "Expenditure": "5.78",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dollar General",
              "Expenditure": "36.03",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "46.57",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "27.81",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }],
          "Leisure": [{
              "Expense Description": "Atif Aslam Concert",
              "Expenditure": "146.58",
              "Category": "Leisure",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Amazon - Catan",
              "Expenditure": "33.3",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Edge at Hudson Yards (NY-Trip)",
              "Expenditure": "95.82",
              "Category": "Leisure",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Airbnb (NY-Trip)",
              "Expenditure": "305",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }, {
              "Expense Description": "Brooklyn Bridge Vendor (NY-Trip)",
              "Expenditure": "11.74",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Preferred"
          }],
          "Restuarant": [{
              "Expense Description": "Grubhub - Mcdonalds",
              "Expenditure": "30.48",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Cava",
              "Expenditure": "28.29",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 4)",
              "Expenditure": "67.78",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 3)",
              "Expenditure": "33.59",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Reebok",
              "Expenditure": "12",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Samsung Watch 4 (Installment 4)",
              "Expenditure": "33.6",
              "Category": "Shopping",
              "Mode of Payment": "WF Checking"
          }],
          "Travel": [{
              "Expense Description": "Delta Airlines (BOS-SJC)",
              "Expenditure": "325.2",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "23.48",
              "Category": "Travel",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "5.5",
              "Category": "Travel",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "MTA NY (NY-Trip)",
              "Expenditure": "81.75",
              "Category": "Travel",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "NYC Fuel Cost (NY-Trip)",
              "Expenditure": "62.25",
              "Category": "Travel",
              "Mode of Payment": "Amex - Preferred"
          }],
          "analytics": {
              "Bill": 2326.16,
              "Grocery": 275.78999999999996,
              "Leisure": 592.44,
              "Restuarant": 58.769999999999996,
              "Shopping": 146.97,
              "Travel": 498.18
          }
      },
      "Nov": {
          "Bill": [{
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "120.98",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "70.95",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "AMC",
              "Expenditure": "7.5",
              "Category": "Bill",
              "Mode of Payment": "Amex"
          }],
          "Grocery": [{
              "Expense Description": "Walgreens",
              "Expenditure": "5.47",
              "Category": "Grocery",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Ashmont Food Market - Convenience",
              "Expenditure": "9.61",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Foodland",
              "Expenditure": "45.92",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "47.55",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "40.45",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "8.37",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Amazon ",
              "Expenditure": "14.01",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }],
          "Leisure": [{
              "Expense Description": "Airbnb (NYC)",
              "Expenditure": "152.15",
              "Category": "Leisure",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "AMC - Coke",
              "Expenditure": "6.94",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "AMC - Bhool Bullaiya",
              "Expenditure": "34.76",
              "Category": "Leisure",
              "Mode of Payment": "Discover"
          }],
          "Restuarant": [{
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "10.24",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Daves Hot Chicken",
              "Expenditure": "33.14",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Dunkin Donuts",
              "Expenditure": "2.56",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Tick Tock Tikka House",
              "Expenditure": "39.26",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Uber Eats - Black Seed Cafe",
              "Expenditure": "30.36",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Ripple Cafe",
              "Expenditure": "3.75",
              "Category": "Restuarant",
              "Mode of Payment": "Amex"
          }],
          "Shopping": [{
              "Expense Description": "Bed (Installment 5)",
              "Expenditure": "67.75",
              "Category": "Shopping",
              "Mode of Payment": "Amex - Everyday"
          }, {
              "Expense Description": "Levi's",
              "Expenditure": "62.55",
              "Category": "Shopping",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "WI Cap",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Men's Warehouse",
              "Expenditure": "4.97",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }],
          "Travel": [{
              "Expense Description": "Lyft",
              "Expenditure": "23.65",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "MBTA",
              "Expenditure": "9.6",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "13.61",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2218.5199999999995,
              "Grocery": 171.38,
              "Leisure": 193.85,
              "Restuarant": 119.31,
              "Shopping": 146.27,
              "Travel": 46.86
          }
      },
      "Dec": {
          "Bill": [{
              "Expense Description": "Uber Eats",
              "Expenditure": "1.66",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Rent",
              "Expenditure": "1960",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Electricity Bill",
              "Expenditure": "112.08",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Water Bill",
              "Expenditure": "73.87",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Internet Bill",
              "Expenditure": "44.87",
              "Category": "Bill",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Renters Insurance",
              "Expenditure": "14.22",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }, {
              "Expense Description": "Mass Tax Payment",
              "Expenditure": "74.39",
              "Category": "Bill",
              "Mode of Payment": "WF Checking"
          }],
          "Grocery": [{
              "Expense Description": "Roche Bros",
              "Expenditure": "15.05",
              "Category": "Grocery",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Amazon - Floss",
              "Expenditure": "2.52",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "CVS",
              "Expenditure": "4.48",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "Walmart",
              "Expenditure": "24.27",
              "Category": "Grocery",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Trader Joes",
              "Expenditure": "49.66",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "7 Eleven",
              "Expenditure": "4.58",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Waltham India Market",
              "Expenditure": "108.03",
              "Category": "Grocery",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "H Mart + Target",
              "Expenditure": "11.86",
              "Category": "Grocery",
              "Mode of Payment": "Chase Credit"
          }],
          "Leisure": [{
              "Expense Description": "Amazon Prime Video - Cosmos",
              "Expenditure": "1.02",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }, {
              "Expense Description": "AMC - Where the Crawdads Sing",
              "Expenditure": "10",
              "Category": "Leisure",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "New England Aquarium",
              "Expenditure": "68",
              "Category": "Leisure",
              "Mode of Payment": "Chase Credit"
          }],
          "Restuarant": [{
              "Expense Description": "AMC Boston Coke",
              "Expenditure": "6.94",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Uber Eats - Side Chick",
              "Expenditure": "17.89",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Grubhub - Halal Guys",
              "Expenditure": "29.61",
              "Category": "Restuarant",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Abreeza's dining with Tooba",
              "Expenditure": "26.13",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }, {
              "Expense Description": "Mike's Pastry",
              "Expenditure": "5",
              "Category": "Restuarant",
              "Mode of Payment": "Chase"
          }],
          "Shopping": [{
              "Expense Description": "Old Navy",
              "Expenditure": "11",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Sephora",
              "Expenditure": "67.56",
              "Category": "Shopping",
              "Mode of Payment": "Amex"
          }, {
              "Expense Description": "Target",
              "Expenditure": "2.3",
              "Category": "Shopping",
              "Mode of Payment": "Discover"
          }, {
              "Expense Description": "Amazon - Mac Charger",
              "Expenditure": "21.24",
              "Category": "Shopping",
              "Mode of Payment": "Chase Credit"
          }],
          "Travel": [{
              "Expense Description": "Uber (NYC)",
              "Expenditure": "20.12",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "MTA Transit (NYC)",
              "Expenditure": "60.5",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft (NYC)",
              "Expenditure": "26.95",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Lyft",
              "Expenditure": "24.74",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "17.69",
              "Category": "Travel",
              "Mode of Payment": "Capital One - QS"
          }, {
              "Expense Description": "Uber",
              "Expenditure": "15.18",
              "Category": "Travel",
              "Mode of Payment": "Capital One - SO"
          }],
          "analytics": {
              "Bill": 2281.0899999999997,
              "Grocery": 220.45,
              "Leisure": 79.02,
              "Restuarant": 85.57,
              "Shopping": 102.1,
              "Travel": 165.18
          }
      }
  }
}
